<script setup lang="ts">
import { useUserStore } from '@/stores/modules/user'
import { formatNumberWithWan } from '@/utils'
import { soulClass, soulList } from '../data'
import { computed } from 'vue'

const userStore = useUserStore()

const emits = defineEmits(['changeSoul'])

const selfSoul = computed(() => soulList.find((item) => item.id === userStore.soulType))
</script>

<template>
  <div class="soul-info-wrap">
    <div class="soul-info border-wrap">
      <h4>战魂信息</h4>
      <p>
        您的战魂：<span :class="soulClass[userStore.soulType]">{{ selfSoul?.name }}</span>
      </p>
      <p>加成：{{ selfSoul?.attrs }}</p>
    </div>

    <p style="text-align: right; font-size: 14px; margin: 5px 0">💎 {{ formatNumberWithWan(userStore.diamond) }}</p>
    <div class="soul-action border-wrap">
      <h4>操作</h4>
      <el-button type="primary" plain @click="emits('changeSoul')">转换（2000钻石）</el-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.soul-info-wrap {
  flex-flow: column nowrap;
  .soul-info {
    margin-bottom: 10px;
    p {
      margin: 5px;
      font-size: 14px;
    }
  }
  .soul-action {
    padding: 0 10px 10px 10px;
    .el-button {
      width: 100%;
    }
  }
}
</style>
